import { FC, ReactNode } from 'react'
import TextArea, { TextAreaProps } from 'antd/es/input/TextArea'
import FieldWrapper from '../FieldWrapper/FieldWrapper'
import cn from './index.module.css'
import classNames from 'classnames'

interface TextAreaFieldProps extends TextAreaProps {
  label?: string
  description?: string
  isInvalid?: boolean
  extraContent?: ReactNode
}

const TextAreaField: FC<TextAreaFieldProps> = ({
  label,
  description,
  isInvalid,
  extraContent,
  className,
  ...props
}) => {
  return (
    <FieldWrapper
      label={label}
      description={description}
      isInvalid={isInvalid}
      extraContent={extraContent}
    >
      <TextArea
        {...props}
        className={classNames(cn.input, isInvalid && cn.invalid, className)}
      />
    </FieldWrapper>
  )
}

export default TextAreaField
